module.exports = __webpack_public_path__ + "files/e5a4be10e86bb1a2020061d40a709461.jpg";